import clsx, { ClassValue } from 'clsx';

/**
 * Utility function to merge class names conditionally
 * Uses clsx for conditional class management
 *
 * @param inputs - Array of class values to merge
 * @returns Merged class string
 *
 * @example
 * cn('base-class', isActive && 'active', 'another-class')
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
